import { Injectable } from '@angular/core';

import { IDocRef } from '@frontend/oxygen/shared-utils';

import { IBetSelection, IParseResponse } from '../betSelection/bet-selection.model';
import { BetSelectionsService } from '../betSelections/bet-selections.service';
import { LegService } from '../leg/leg.service';
import { SportsLegPriceService } from '../sportsLegPrice/sports-leg-price.service';
import { SportsLeg } from './sports-leg';

@Injectable({ providedIn: 'root' })
export class SportsLegService extends LegService {
    static ngInjectableDef = undefined;

    constructor(
        public sportsLegPriceService: SportsLegPriceService,
        public override betSelectionService: BetSelectionsService,
    ) {
        super(betSelectionService);
    }

    override construct(selection: IBetSelection, docId: number, partsType?: any): SportsLeg {
        return new SportsLeg(this.sportsLegPriceService, this.betSelectionService, selection, docId, partsType);
    }

    override parse(root: IDocRef): IParseResponse {
        const docId = root.documentId,
            sportsLeg = root.sportsLeg,
            legParts = sportsLeg?.legPart || [],
            winPlace = <string>sportsLeg?.winPlaceRef?.id || '',
            price = sportsLeg?.price,
            priceObj = price
                ? this.sportsLegPriceService.parse(price)
                : this.sportsLegPriceService.parse({ priceNum: 0, priceDen: 0, priceType: '' }),
            combi = <string | undefined>(sportsLeg?.outcomeCombiRef && sportsLeg?.outcomeCombiRef.id) || undefined,
            outcomes = legParts.map((part) => {
                const outcomeId = part.outcomeRef.id;
                return {
                    id: outcomeId,
                    price: priceObj,
                };
            });
        return {
            docId,
            legParts,
            winPlace,
            price: priceObj,
            combi,
            outcomes,
        };
    }
}
